// extracted by mini-css-extract-plugin
export var box = "_50-1";
export var checkboxRow = "_50-8";
export var checked = "_50-2";
export var descriptionSpacer = "_50-a";
export var disabled = "_50-3";
export var icon = "_50-6";
export var input = "_50-0";
export var labelSpacer = "_50-9";
export var medium = "_50-5";
export var small = "_50-4";
export var text = "_50-7";